import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!!$props.morticianName)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createTextVNode(_toDisplayString($props.morticianName), 1),
        _hoisted_2,
        (!!$props.morticianPhoneNumber)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Tel.: " + _toDisplayString($props.morticianPhoneNumber), 1))
          : _createCommentVNode("", true),
        (!!$props.morticianEmail)
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, "E-Mail: " + _toDisplayString($props.morticianEmail), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}